import React from 'react';
import Head from 'next/head';

interface TitleProps {
    title: string;
}

const PageTitle = ({ title }: TitleProps) => {
    return (
        <Head>
            <title>{title}</title>
        </Head>
    );
};
export default PageTitle;
